import React, { useEffect, useState, useRef } from "react";
import ReactDOM from "react-dom";
import { SlideManager, SlideOptions } from "./SlideManager";
import {
  SlidePopupWrapper,
  Backdrop,
  SlideContainer,
  CloseButtonWrapper,
  SlideContent,
  SlideDirection,
} from "./style";
import Button from "components/atoms/Button";

interface SlideState extends SlideOptions {
  isExiting: boolean;
}

const SlidePopup: React.FC = () => {
  const [visible, setVisible] = useState(false);
  const [options, setOptions] = useState<SlideOptions | null>(null);
  const [isExiting, setIsExiting] = useState(false);
  const timerId = useRef<number | null>(null);

  useEffect(() => {
    const handleChange = (state: { visible: boolean; options: SlideOptions | null }) => {
      if (state.visible && state.options) {
        // 새 슬라이드가 표시되는 경우
        if (timerId.current) {
          clearTimeout(timerId.current);
          timerId.current = null;
        }
        setIsExiting(false);
        setVisible(true);
        setOptions(state.options);
      } else if (!state.visible && visible) {
        // 슬라이드가 닫히는 경우
        setIsExiting(true);
        timerId.current = window.setTimeout(() => {
          setVisible(false);
          setOptions(null);
          timerId.current = null;
        }, 500); // 애니메이션 지속 시간과 일치시킴
      }
    };

    SlideManager.addListener(handleChange);
    return () => {
      SlideManager.removeListener(handleChange);
      if (timerId.current) {
        clearTimeout(timerId.current);
        timerId.current = null;
      }
    };
  }, [visible]);

  const handleBackdropClick = () => {
    SlideManager.hide();
  };

  // 보여줄 것이 없으면 아무것도 렌더링하지 않음
  if (!visible || !options) return null;

  const direction = (options.direction || "right") as SlideDirection;

  // Portal을 사용하여 body에 직접 렌더링
  return ReactDOM.createPortal(
    <SlidePopupWrapper $noBackdrop={options.noBackdrop}>
      <Backdrop isExiting={isExiting} onClick={handleBackdropClick} $noBackdrop={options.noBackdrop} />
      <SlideContainer
        direction={direction}
        isExiting={isExiting}
        width={options.width}
        minWidth={options.minWidth}
        height={options.height}
        padding={options.padding}
      >
        {options.needCloseButton && (
          <CloseButtonWrapper>
            <Button
              type="Icon"
              size="Medium"
              variant="Ghost"
              color="Tertiary"
              icon="X"
              onClick={() => SlideManager.hide()}
            />
          </CloseButtonWrapper>
        )}
        <SlideContent>{options.body}</SlideContent>
      </SlideContainer>
    </SlidePopupWrapper>,
    document.body
  );
};

export default SlidePopup;
